import apiClient from "./apiClient";

export const fetchGallery = async () => {
    const response = await apiClient.get("/api/about_company");
    return response.data;
};

export const updateGallery = async (id, formData) => {
    const response = await apiClient.put(`/api/about_company/${id}`, formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
    return response.data;
};